import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import MOCK_DATA from '../table/SortingTable/MOCK_DATA_3.json';
import BootstrapTable from "../../components/table/BootstrapTable";
import RTBFTable from "../../components/table/RtbfTable";
import RTBFActionsTable from "../../components/table/RtbfActionsTable";
import { useTable, useFilters, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { Sparklines, SparklinesLine } from "react-sparklines";
import {
    Row,
    Col,
    Card,
    Button,
    ButtonGroup,
    Dropdown,
    Accordion,
    DropdownButton,
    Table,
    Alert
} from "react-bootstrap";

// eddie
import { useOktaAuth } from '@okta/okta-react';
import { getNewRrtbfApprovalTasks, getNewClassificationApprovalTasks, submitClassificationApprovalTask, getClassificationApprovalHistory, getRrtbfApprovalHistory, submitRTBFApprovalTasks } from '../../../services/ApprovalService';
import avatar1 from "../../../images/avatar/1.jpg";
import avatar2 from "../../../images/avatar/2.jpg";
import avatar3 from "../../../images/avatar/3.jpg";


//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import PaymentTable from './Elements/PaymentTable';
import TopProducts from './Elements/TopProducts';
import ActivityTab from './Elements/ActivityTab';
import UserActivity from './Elements/UserActivity';
import { useMsal } from '@azure/msal-react';


const AreaChart2Canvas = loadable(() =>
    pMinDelay(import("./Elements/AreaChart2Canvas"), 1000)
);
const ChartWidget2 = loadable(() =>
    pMinDelay(import("./Elements/ChartWidget2"), 1000)
);
const ShareProfitCanvas2 = loadable(() =>
    pMinDelay(import("./Elements/ShareProfitCanvas2"), 1000)
);
const ActiveUserCanvas = loadable(() =>
    pMinDelay(import("./Elements/ActiveUserCanvas"), 1000)
);

const sampleData = [6, 2, 8, 4, 3, 8, 4, 3, 6, 5, 9, 2,];

const svg1 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
        <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M5.74714567,13.0425758 C4.09410362,11.9740356 3,10.1147886 3,8 C3,4.6862915 5.6862915,2 9,2 C11.7957591,2 14.1449096,3.91215918 14.8109738,6.5 L17.25,6.5 C19.3210678,6.5 21,8.17893219 21,10.25 C21,12.3210678 19.3210678,14 17.25,14 L8.25,14 C7.28817895,14 6.41093178,13.6378962 5.74714567,13.0425758 Z" fill="#000000" opacity="0.3"></path>
            <path d="M11.1288761,15.7336977 L11.1288761,17.6901712 L9.12120481,17.6901712 C8.84506244,17.6901712 8.62120481,17.9140288 8.62120481,18.1901712 L8.62120481,19.2134699 C8.62120481,19.4896123 8.84506244,19.7134699 9.12120481,19.7134699 L11.1288761,19.7134699 L11.1288761,21.6699434 C11.1288761,21.9460858 11.3527337,22.1699434 11.6288761,22.1699434 C11.7471877,22.1699434 11.8616664,22.1279896 11.951961,22.0515402 L15.4576222,19.0834174 C15.6683723,18.9049825 15.6945689,18.5894857 15.5161341,18.3787356 C15.4982803,18.3576485 15.4787093,18.3380775 15.4576222,18.3202237 L11.951961,15.3521009 C11.7412109,15.173666 11.4257142,15.1998627 11.2472793,15.4106128 C11.1708299,15.5009075 11.1288761,15.6153861 11.1288761,15.7336977 Z" fill="#000000" fill-rule="nonzero" transform="translate(11.959697, 18.661508) rotate(-270.000000) translate(-11.959697, -18.661508) "></path>
        </g>
    </svg>
);


const DataClassificationApprovals = () => {
    // 1) This goes at the top level of your component
    const [selectedFilters, setSelectedFilters] = useState({});
    // e.g. { env: ['dev', 'qa'], db_name: ['someDB'] }

    const [uniqueValuesMap, setUniqueValuesMap] = useState({});
    // e.g. { env: ['dev','qa','prod'], db_name: ['example1','example2'] }

    const [newClassificationApprovalTasks, setNewClassificationApprovalTasks] = useState([]);



    const [taskSummaries, setTaskSummaries] = useState([]);


    const [classificationApprovalHistory, setClassificationApprovalHistory] = useState([]);


    const [selectedClassificationApprovals, setSelectedClassificationApprovals] = useState([classificationApprovalHistory]);


    const [loadingElement, setLoadingElement] = useState(false); // New state for loading UI


    const [selectPiiCompOption, setSelectedPiiCompOption] = useState('');


    const [selectedPiiOption, setSelectedPiiOption] = useState('');

    const [selectClassificationTypeOption, setSelectedClassificationTypeOption] = useState('');


    const [selectAssociatePiiOption, setSelectedAssociatePiition] = useState('');


    const [showIncompleteAlert, setShowIncompleteAlert] = useState(false);



    const { instance, accounts } = useMsal();

    const readerUserGroups = ['sri.mandavilli@lennar.com', 'abram.bachtiar@lennar.com', 'ben.locke@lennar.com', 'lee.slezak@lennar.com', 'varun.kumar@lennar.com']
    const adminUserGroups = ['eddie.ruiz@lennar.com', 'arya.singh@lennar.com', 'isaac.gabay@lennar.com', 'yasmin.chaffo@lennar.com', 'valorie.artz@lennar.com', 'victor.oluleke@lennar.com', 'carlos.garcell@lennar.com',]


    const username = useMemo(() => {
        const name = accounts[0].name ?? "Unknown";

        return name;
    }, [accounts]);

    const userEmail = useMemo(() => {
        const email = accounts[0].username ?? "Unknown";

        return email;
    }, [accounts]);




    const [adminUserType, setAdminUserType] = useState();


    const [batchApprovals, setBatchApprovals] = useState([]);


    const [showEdmAlert, setShowEdmAlert] = useState(false);


    const [showDenyAlert, setShowDenyAlert] = useState(false);
    const [showDenyAllAlert, setShowDenyAllAlert] = useState(false);


    const [showApproveAlert, setShowApproveAlert] = useState(false);


    const [showRequestSampleDataAlert, setShowRequestSampleDataAlert] = useState(false);


    const [currentApprovalIndex, setCurrentApprovalIndex] = useState(null);

    const [sampleDataApproval, setSampleDataApproval] = useState(null);


    const [dropdownSelections, setDropdownSelections] = useState(
        newClassificationApprovalTasks.map(task => ({
            selectedPiiOption: task.PII_TYPE,
            selectClassificationTypeOption: task.CLASSIFICATION_TYPE,
            selectAssociatePiiOption: task.PII,
            selectPiiCompOption: task.PII_COMP
        }))
    );



    const [showSuccessfulClassificationApprovalAlert, setShowSuccessfulClassificationApprovalAlert] = useState(false);

    const [showFailureClassificationApprovalAlert, setShowFailureClassificationApprovalAlert] = useState(false);
    const ColumnFilter = ({ column }) => {

        const { filterValue, setFilter } = column
        return (
            <div>

                <input className="form-control input-search"
                    value={filterValue || ''} onChange={e => setFilter(e.target.value)} />
            </div>
        )
    }

    const ObjectNameFilter = () => {
        const [showPopup, setShowPopup] = React.useState(false);

        // Get the unique values for 'table_name' (adjust to your own data/props)
        const envValues = uniqueValuesMap?.TABLE_NAME || [];

        // Toggle pop-up
        const handleIconClick = () => setShowPopup((prev) => !prev);

        return (
            // Use inline-flex + relative positioning so it sits nicely next to the text input
            <div style={{ display: 'inline-flex', position: 'relative', marginLeft: '6px' }}>
                <button className="btn btn-sm btn-light" onClick={handleIconClick}>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                </button>

                {showPopup && (
                    <div
                        className="col-xl-6 col-lg-6"
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: 0,
                            zIndex: 999,
                            minWidth: '250px',
                        }}
                    >
                        <div className="card">

                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div
                                            className="form-group"
                                            style={{ maxHeight: '250px', overflowY: 'auto' }}
                                        >
                                            {envValues.map((val) => {
                                                const isChecked = (selectedFilters.TABLE_NAME || []).includes(val);
                                                return (
                                                    <div className="form-check mb-2" key={val}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`TABLE_NAME-${val}`}
                                                            value={val}
                                                            checked={isChecked}
                                                            onChange={() => toggleFilterValue('TABLE_NAME', val)}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`TABLE_NAME-${val}`}
                                                        >
                                                            {val}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    const SchemaNameFilter = () => {
        const [showPopup, setShowPopup] = React.useState(false);

        // Get the unique values for 'schema_name'
        const schemaValues = uniqueValuesMap?.SCHEMA_NAME || [];

        const handleIconClick = () => setShowPopup((prev) => !prev);

        return (
            <div style={{ display: 'inline-flex', position: 'relative', marginLeft: '6px' }}>
                <button className="btn btn-sm btn-light" onClick={handleIconClick}>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                </button>

                {showPopup && (
                    <div
                        className="col-xl-6 col-lg-6"
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: 0,
                            zIndex: 999,
                            minWidth: '250px',
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="form-group" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {schemaValues.map((val) => {
                                                const isChecked = (selectedFilters.SCHEMA_NAME || []).includes(val);
                                                return (
                                                    <div className="form-check mb-2" key={val}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`SCHEMA_NAME-${val}`}
                                                            value={val}
                                                            checked={isChecked}
                                                            onChange={() => toggleFilterValue('SCHEMA_NAME', val)}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`SCHEMA_NAME-${val}`}
                                                        >
                                                            {val}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const ColumnNameFilterCheckbox = () => {
        const [showPopup, setShowPopup] = React.useState(false);

        // Get the unique values for 'column_name'
        const colValues = uniqueValuesMap?.COLUMN_NAME || [];

        const handleIconClick = () => setShowPopup((prev) => !prev);

        return (
            <div style={{ display: 'inline-flex', position: 'relative', marginLeft: '6px' }}>
                <button className="btn btn-sm btn-light" onClick={handleIconClick}>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                </button>

                {showPopup && (
                    <div
                        className="col-xl-6 col-lg-6"
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: 0,
                            zIndex: 999,
                            minWidth: '250px',
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="form-group" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {colValues.map((val) => {
                                                const isChecked = (selectedFilters.COLUMN_NAME || []).includes(val);
                                                return (
                                                    <div className="form-check mb-2" key={val}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`COLUMN_NAME-${val}`}
                                                            value={val}
                                                            checked={isChecked}
                                                            onChange={() => toggleFilterValue('COLUMN_NAME', val)}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`COLUMN_NAME-${val}`}
                                                        >
                                                            {val}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const DatabaseNameFilter = () => {
        const [showPopup, setShowPopup] = React.useState(false);

        // Get the unique values for 'db_name'
        const dbValues = uniqueValuesMap?.DB_NAME || [];

        const handleIconClick = () => setShowPopup((prev) => !prev);

        return (
            <div style={{ display: 'inline-flex', position: 'relative', marginLeft: '6px' }}>
                <button className="btn btn-sm btn-light" onClick={handleIconClick}>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                </button>

                {showPopup && (
                    <div
                        className="col-xl-6 col-lg-6"
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: 0,
                            zIndex: 999,
                            minWidth: '250px',
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="form-group" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {dbValues.map((val) => {
                                                const isChecked = (selectedFilters.DB_NAME || []).includes(val);
                                                return (
                                                    <div className="form-check mb-2" key={val}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`DB_NAME-${val}`}
                                                            value={val}
                                                            checked={isChecked}
                                                            onChange={() => toggleFilterValue('DB_NAME', val)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`DB_NAME-${val}`}>
                                                            {val}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };
    const EnvFilter = () => {
        const [showPopup, setShowPopup] = React.useState(false);

        // Get the unique values for 'env'
        const envValues = uniqueValuesMap?.ENV || [];

        const handleIconClick = () => setShowPopup((prev) => !prev);

        return (
            <div style={{ display: 'inline-flex', position: 'relative', marginLeft: '6px' }}>
                <button className="btn btn-sm btn-light" onClick={handleIconClick}>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                </button>

                {showPopup && (
                    <div
                        className="col-xl-6 col-lg-6"
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: 0,
                            zIndex: 999,
                            minWidth: '250px',
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="form-group" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {envValues.map((val) => {
                                                const isChecked = (selectedFilters.ENV || []).includes(val);
                                                return (
                                                    <div className="form-check mb-2" key={val}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`ENV-${val}`}
                                                            value={val}
                                                            checked={isChecked}
                                                            onChange={() => toggleFilterValue('ENV', val)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`ENV-${val}`}>
                                                            {val}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };
    const GlobalFilter = ({ filter, setFilter }) => {

        return (
            <div>
                Global Search : {' '}
                <input className="ml-2 input-search form-control"
                    value={filter || ''} onChange={e => setFilter(e.target.value)} style={{ width: "100%" }}
                />
            </div>
        )
    }
    const columns = useMemo(
        () => [
            {
                Header: 'Action',
                accessor: 'action',
                disableFilters: true,
                Cell: ({ row }) => {
                    const index = row.index;
                    const approval = row.original;


                    return (
                        <div className="d-flex">
                            <a
                                href="#"
                                className="btn btn-success btn-xs sharp me-1"
                                onClick={() => handleApproveAlert(index)}
                            >
                                <i className="fa fa-check"></i>
                            </a>
                            {/* Approve Alert */}
                            {showApproveAlert && currentApprovalIndex === index && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '55%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 1050,
                                        width: '80%',
                                        maxWidth: '600px'
                                    }}
                                >
                                    <Alert
                                        variant="primary"
                                        className="notification"
                                        onClose={() => setShowApproveAlert(false)}
                                        dismissible
                                    >
                                        <p className="notification-title mb-2">
                                            <strong>Are you sure?</strong>
                                        </p>
                                        <p>Are you sure you want to classify this record?</p>
                                        <div>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                onClick={(e) => {
                                                    handleConfirmApproval(e, approval, index);
                                                    setShowApproveAlert(false);

                                                }}
                                            >
                                                Confirm
                                            </Button>{' '}
                                            <Button variant="link" size="sm" onClick={() => setShowApproveAlert(false)}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </Alert>
                                </div>
                            )}

                            <a
                                href="#"
                                className="btn btn-danger btn-xs sharp"
                                onClick={() => handleDenyAlert(index)}
                            >
                                <i className="fa fa-x"></i>
                            </a>
                            {/* Deny Alert */}
                            {showDenyAlert && currentApprovalIndex === index && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '55%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 1050,
                                        width: '80%',
                                        maxWidth: '600px'
                                    }}
                                >
                                    <Alert
                                        variant="danger"
                                        className="notification"
                                        onClose={() => setShowDenyAlert(false)}
                                        dismissible
                                    >
                                        <p className="notification-title mb-2">
                                            <strong>Are you sure?</strong>
                                        </p>
                                        <p>Are you sure you want to deny this record?</p>
                                        <div>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={(e) => {
                                                    handleDenyApproval(e, approval, index);
                                                    setShowDenyAlert(false); // Close the alert
                                                }}
                                            >
                                                Deny
                                            </Button>{' '}
                                            <Button variant="link" size="sm" onClick={() => setShowDenyAlert(false)}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </Alert>
                                </div>
                            )}

                            {showIncompleteAlert && currentApprovalIndex === index && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '55%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 1050,
                                        width: '80%',
                                        maxWidth: '600px'
                                    }}
                                >
                                    <Alert
                                        variant="danger"
                                        className="notification"
                                        onClose={() => setShowIncompleteAlert(false)}
                                        dismissible
                                    >
                                        <p className="notification-title mb-2">
                                            <strong>Incomplete Selection</strong>
                                        </p>
                                        <p>Please complete all selections before proceeding.</p>
                                        <div>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={(e) => {
                                                    setShowIncompleteAlert(false);
                                                }}
                                            >
                                                Close
                                            </Button>{' '}
                                            <Button variant="link" size="sm" onClick={() => setShowIncompleteAlert(false)}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </Alert>
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                Header: 'ENVIRONMENT',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ColumnFilter column={column} />
                        <EnvFilter />
                    </div>
                ),
                accessor: 'ENV'
            },
            {
                Header: 'DATABASE',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ColumnFilter column={column} />
                        <DatabaseNameFilter />
                    </div>
                ),
                accessor: 'DB_NAME'
            },

            {
                Header: 'SCHEMA_NAME',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ColumnFilter column={column} />
                        <SchemaNameFilter />
                    </div>
                ),
                accessor: 'SCHEMA_NAME'
            },
            {
                Header: 'OBJECT_NAME',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ColumnFilter column={column} />
                        <ObjectNameFilter />
                    </div>
                ),
                accessor: 'TABLE_NAME'
            },
            {
                Header: 'COLUMN NAME',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ColumnFilter column={column} />
                        <ColumnNameFilterCheckbox />
                    </div>
                ),
                accessor: 'COLUMN_NAME'
            },
            {
                Header: () => (
                    <span>
                        PII Type <span style={{ color: 'red' }}>*</span>
                    </span>
                ),
                accessor: 'pii_type',
                disableFilters: true,
                Cell: ({ row }) => {
                    const index = row.index;
                    const approval = row.original;
                    return (
                        <div className="color-primary">
                            <Dropdown onSelect={(eventKey) => handleDropdownSelect(index, 'selectedPiiOption', eventKey, approval)}>
                                <Dropdown.Toggle variant="none">
                                    {dropdownSelections[index].selectedPiiOption || "Select"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="Sensitive">Sensitive</Dropdown.Item>
                                    <Dropdown.Item eventKey="Personal">Personal</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    );
                }
            },

            // {
            //     Header: 'PII_COMP',
            //     disableFilters: true,
            //     accessor: 'pii_comp',
            //     Cell: ({ row }) => {
            //         const index = row.index;
            //         const approval = row.original;
            //         return (
            //             <div className="color-primary">
            //                 <Dropdown onSelect={(eventKey) => handleDropdownSelect(index, 'selectPiiCompOption', eventKey, approval)}>
            //                     <Dropdown.Toggle variant="none">
            //                         {dropdownSelections[index].selectPiiCompOption || "Select"}
            //                     </Dropdown.Toggle>
            //                     <Dropdown.Menu>
            //                         <Dropdown.Item eventKey="Yes">Yes</Dropdown.Item>
            //                         <Dropdown.Item eventKey="No">No</Dropdown.Item>
            //                     </Dropdown.Menu>
            //                 </Dropdown>
            //             </div>
            //         );
            //     }
            // },
            {
                Header: () => (
                    <span>
                        CLASSIFICATION TYPE <span style={{ color: 'red' }}>*</span>
                    </span>
                ),
                accessor: 'classification_type',
                disableFilters: true,
                Cell: ({ row }) => {
                    const index = row.index;
                    const approval = row.original;
                    return (
                        <div className="color-primary">
                            <Dropdown onSelect={(eventKey) => handleDropdownSelect(index, 'selectClassificationTypeOption', eventKey, approval)}>
                                <Dropdown.Toggle variant="none">
                                    {dropdownSelections[index].selectClassificationTypeOption || "Select"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="Confidential">Confidential</Dropdown.Item>
                                    <Dropdown.Item eventKey="Internal">Internal</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    );
                }
            },
            {
                Header: 'ASSOCIATE PII',
                accessor: 'associate_pii',
                disableFilters: true,
                Cell: ({ row }) => {
                    const index = row.index;
                    const approval = row.original;
                    return (
                        <div className="color-primary">
                            <Dropdown onSelect={(eventKey) => handleDropdownSelect(index, 'selectAssociatePiiOption', eventKey, approval)}>
                                <Dropdown.Toggle variant="none">
                                    {dropdownSelections[index].selectAssociatePiiOption || "Select"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="Yes">Yes</Dropdown.Item>
                                    <Dropdown.Item eventKey="No">No</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    );
                }
            }
            ,
            {
                Header: 'Sample Data',
                Filter: ({ column }) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>

                        {/* <ColumnFilter column={column} /> */}
                        {/* <DatabaseNameFilter /> */}
                    </div>
                ),
                accessor: 'SAMPLE_DATA',

                Cell: ({ row, value }) => {
                    const index = row.index;
                    const approval = row.original;
                    // If PII is not always defined and PII_TYPE is a fallback:

                    return <Button className="me-2" variant="outline-secondary" onClick={(e) => handleShowRequestSampleDataAlert(e, approval, index)}>
                        Request Sample Data
                    </Button>;
                }
            },
        ],
        [dropdownSelections, currentApprovalIndex, showApproveAlert, showDenyAlert, showIncompleteAlert, selectedFilters, uniqueValuesMap]
    );

    // const data = useMemo(() => newClassificationApprovalTasks, [newClassificationApprovalTasks]);
    const filteredTasks = useMemo(() => {
        // If no filters are selected, just return the data
        const noFiltersSelected = Object.values(selectedFilters).every((arr) => !arr?.length);
        if (noFiltersSelected) return newClassificationApprovalTasks;

        // Otherwise, filter row by row
        return newClassificationApprovalTasks.filter((task) => {
            // For each column that has selected filters,
            // the task's value must be one of the selected values
            for (const [colKey, selectedVals] of Object.entries(selectedFilters)) {
                if (selectedVals.length > 0 && !selectedVals.includes(task[colKey])) {
                    return false;
                }
            }
            return true;
        });
    }, [newClassificationApprovalTasks, selectedFilters]);

    // Create table instance
    // const tableInstance = useTable({ columns, data: filteredTasks }, useFilters, useGlobalFilter, useSortBy, usePagination)
    const data = useMemo(() => filteredTasks, [filteredTasks]);
    const tableInstance = useTable(
        {
            columns,
            data,
            // This is the important part to override the defaults
            initialState: {
                pageIndex: 0,   // (Optional) start on the first page
                pageSize: 20,    // (Required) show 5 rows per page
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canNextPage,
        canPreviousPage,
        nextPage,
        previousPage,
        gotoPage,
        pageCount,
        pageOptions,
        state,
        setGlobalFilter,
        preGlobalFilteredRows,
    } = tableInstance;

    const { globalFilter, pageIndex } = state;
    const { setPageSize } = tableInstance;

    useEffect(() => {
        setPageSize(20);
    }, [data, setPageSize]);


    const historyColumns = useMemo(() => [
        {
            Header: 'Status',
            Filter: ColumnFilter,
            accessor: 'APPROVAL', // property from classificationApprovalHistory
            Cell: ({ cell: { value } }) => {
                const statusClass = value === "Approved" ? 'text-success' : 'text-danger';
                return <span className={statusClass}>{value.charAt(0).toUpperCase() + value.slice(1)}</span>;
            }
        },
        {
            Header: 'Approved By',
            Filter: ColumnFilter,
            accessor: 'APPROVED_BY', // If not in your data, you can hardcode or map a field.
            Cell: () => 'Compliance Team', // Hardcoded value as per your original table
        },
        {
            Header: 'DATABASE',
            Filter: ColumnFilter,
            accessor: 'SOURCE_DB',
        },
        {
            Header: 'SCHEMA_NAME',
            Filter: ColumnFilter,
            accessor: 'SOURCE_SYSTEM',
        },
        {
            Header: 'OBJECT_NAME',
            Filter: ColumnFilter,
            accessor: 'ATHENIX_OBJECT', // Using same accessor as schema_name based on original code
        },
        {
            Header: 'COLUMN NAME',
            Filter: ColumnFilter,
            accessor: 'ATHENIX_FIELDS',
            Cell: ({ value }) => <span className="color-primary">{value}</span>
        },
        {
            Header: 'PII Type',
            accessor: 'PII',
            Filter: ColumnFilter,
            Cell: ({ row, value }) => {
                // If PII is not always defined and PII_TYPE is a fallback:
                const finalValue = value || row.original.PII_TYPE;
                return <span className="color-primary">{finalValue}</span>;
            }
        },
        // {
        //     Header: 'PII COMP',
        //     accessor: 'PII_COMP',
        //     Filter: ColumnFilter,
        //     Cell: ({ value }) => <span className="color-primary">{value}</span>
        // },
        {
            Header: 'CLASSIFICATION TYPE',
            accessor: 'CLASSIFICATION_TYPE',
            Filter: ColumnFilter,
            Cell: ({ value }) => <span className="color-primary">{value}</span>
        },
        {
            Header: 'Tag Applied',
            accessor: 'APPLY_TAG',
            Filter: ColumnFilter,
            Cell: ({ value }) => <span className="color-primary">{value}</span>
        }
    ], []);
    const historyData = useMemo(() => classificationApprovalHistory, [classificationApprovalHistory]);


    // Create table instance for history
    const tableHistoryInstance = useTable(
        { columns: historyColumns, data: historyData },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps: getHistoryTableProps,
        getTableBodyProps: getHistoryTableBodyProps,
        headerGroups: historyHeaderGroups,
        prepareRow: prepareHistoryRow,
        page: historyPage,
        canNextPage: historyCanNextPage,
        canPreviousPage: historyCanPreviousPage,
        nextPage: historyNextPage,
        previousPage: historyPreviousPage,
        gotoPage: historyGotoPage,
        pageCount: historyPageCount,
        pageOptions: historyPageOptions,
        state: historyState,
        setGlobalFilter: setHistoryGlobalFilter,
        preGlobalFilteredRows: preHistoryGlobalFilteredRows,
    } = tableHistoryInstance;

    const { globalFilter: historyGlobalFilter, pageIndex: historyPageIndex } = historyState;



    const {
        changeBackground,
        changeSideBarStyle,
        chnageSidebarColor,
        changeNavigationHader
    } = useContext(ThemeContext);




    const toggleFilterValue = (colAccessor, value) => {
        setSelectedFilters((prev) => {
            const currentValues = prev[colAccessor] || [];
            // If already selected, remove it; otherwise, add it
            const newValues = currentValues.includes(value)
                ? currentValues.filter((val) => val !== value)
                : [...currentValues, value];

            return { ...prev, [colAccessor]: newValues };
        });
    };

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);


    useEffect(() => {
        changeBackground({ value: "light", label: "Light" });
        changeSideBarStyle({ value: "mini", label: "Mini" });
        chnageSidebarColor("color_3");
        changeNavigationHader("color_3");

        if (adminUserGroups.includes(userEmail)) {
            console.log("User is an admin: ");
            setAdminUserType(true);
        } else {
            console.log("User is not an admin: ");
            setAdminUserType(false);
        }

        async function fetchData() {

            try {


                const classificationApprovalHistory = await getClassificationApprovalHistory(userEmail);

                setClassificationApprovalHistory(classificationApprovalHistory);



                const newClassificationApprovalTasks = await getNewClassificationApprovalTasks(userEmail);

                if (newClassificationApprovalTasks.length > 0) {
                    const map = {};
                    // For whichever columns you want checkboxes:
                    ['ENV', 'DB_NAME', 'SCHEMA_NAME', 'TABLE_NAME', 'COLUMN_NAME'].forEach((col) => {
                        const uniqueVals = new Set();
                        newClassificationApprovalTasks.forEach((row) => {
                            uniqueVals.add(row[col]);
                        });
                        map[col] = [...uniqueVals];
                    });

                    setUniqueValuesMap(map);
                }


                // Initialize tasks with a 'checked' property
                const tasksWithChecked = newClassificationApprovalTasks.map(item => ({
                    ...item,
                    checked: false
                }));
                setNewClassificationApprovalTasks(tasksWithChecked);

                // Initialize dropdown selections
                setDropdownSelections(tasksWithChecked.map(task => ({
                    selectedPiiOption: task.PII_TYPE,
                    selectClassificationTypeOption: task.CLASSIFICATION_TYPE,
                    selectAssociatePiiOption: task.PII,
                    selectPiiCompOption: task.PII_COMP
                })));

                // Generate the summary
                const taskSummary = {};

                tasksWithChecked.forEach(task => {
                    const { ENV, DB_NAME, TABLE_NAME, COLUMN_NAME } = task;
                    if (!taskSummary[ENV]) {
                        taskSummary[ENV] = {
                            taskCount: 0,
                            dbNames: new Set(),
                            tableNames: new Set(),
                            columnCount: 0
                        };
                    }
                    taskSummary[ENV].taskCount += 1;
                    taskSummary[ENV].dbNames.add(DB_NAME);
                    taskSummary[ENV].tableNames.add(TABLE_NAME);
                    taskSummary[ENV].columnCount += 1; // Increment column count
                });

                // Create summary strings
                const summaries = Object.keys(taskSummary).map(env => {
                    const { taskCount, dbNames, tableNames, columnCount } = taskSummary[env];
                    const dbNamesStr = Array.from(dbNames).join(', ');
                    const tableNamesStr = Array.from(tableNames).join(', ');
                    const dbLabel = dbNames.size === 1 ? "db" : "db's";
                    return `You have ${columnCount} columns to approve or deny in environment(s) ${env}, in ${dbLabel} ${dbNamesStr} in tables ${tableNamesStr}`;
                });


                // If you want to display these summaries in your component, you can set them in state
                setTaskSummaries(summaries);



            } catch (error) {
                console.error("Error fetching approvals:", error);
            }
        }

        fetchData();
    }, [userEmail]);





    const handleApproveAlert = (index) => {

        if (index) {
            setCurrentApprovalIndex(index);
            setShowApproveAlert(true);
        } else {

            setShowApproveAlert(true);
        }
    };

    const handleShowRequestSampleDataAlert = (e, approval, index) => {
        e.preventDefault();

        setShowRequestSampleDataAlert(true);
        setSampleDataApproval(approval);
    }
    const handleDenyAlert = (index) => {
        if (index) {
            setCurrentApprovalIndex(index);
            setShowDenyAlert(true); // Show the custom alert
        } else {
            setShowDenyAlert(true);
        }
    };
    const handleDenyAllAlert = () => {
        setShowDenyAllAlert(true);
    }
    const handleEDMTeamConnect = () => {
        setShowEdmAlert(true);
    };

    const handleIncompleteAlert = () => {

        setShowIncompleteAlert(true);
    };

    const handleClassificationTypeSelect = (eventKey) => {

        setSelectedClassificationTypeOption(eventKey);
    };
    const handleAssociateSelect = (eventKey) => {

        setSelectedAssociatePiition(eventKey);
    };
    const handleConfirmApproval = async (e, approval, index) => {
        e.preventDefault();
        setLoadingElement(true); // Start Loading Indicator

        try {

            const currentSelection = dropdownSelections[currentApprovalIndex];
            if (!currentSelection.selectPiiCompOption && !currentSelection.selectedPiiOption) {
                handleIncompleteAlert();
                setLoadingElement(false); // Stop Loading if Incomplete
                return;
            }

            const newApproval = {
                ENV: approval.ENV,
                SOURCE_SYSTEM: approval.SCHEMA_NAME,
                ATHENIX_OBJECT: approval.TABLE_NAME,
                ATHENIX_FIELDS: approval.COLUMN_NAME,
                Definition: approval.DATA,
                PII_CHART: approval.PII_CHART || '',
                'PII Y/N': approval.PII,
                PII_COMP: currentSelection.selectPiiCompOption,
                PII: currentSelection.selectAssociatePiiOption,
                PII_TYPE: currentSelection.selectedPiiOption,
                CLASSIFICATION_TYPE: currentSelection.selectClassificationTypeOption,
                RTBF: approval.RTBF || '',
                APPLY_TAG: approval.APPLY_TAG,
                SOURCE_DB: approval.DB_NAME,
                APPROVED: 'Approved',
                ID: currentApprovalIndex || ''
            };

            const result = await submitClassificationApprovalTask(newApproval);
            if (result) setShowSuccessfulClassificationApprovalAlert(true);

        } catch (error) {
            console.error("Error submitting classification approval task:", error);
            setShowFailureClassificationApprovalAlert(true);
        } finally {
            setLoadingElement(false); // Stop Loading
        }
    };

    const handleAllApprovals = async (e) => {
        e.preventDefault();
        setLoadingElement(true); // Start Loading Indicator

        try {

            const approvalPayloads = [];

            batchApprovals.forEach((approval) => {
                const currentSelection = dropdownSelections.find(selection =>
                    selection.approval?.DB_NAME === approval.DB_NAME &&
                    selection.approval?.SCHEMA_NAME === approval.SCHEMA_NAME &&
                    selection.approval?.TABLE_NAME === approval.TABLE_NAME &&
                    selection.approval?.COLUMN_NAME === approval.COLUMN_NAME
                );

                if (!currentSelection) return;
                if (!currentSelection.selectPiiCompOption && !currentSelection.selectedPiiOption) {
                    handleIncompleteAlert();
                    return;
                }

                approvalPayloads.push({
                    ENV: approval.ENV,
                    SOURCE_SYSTEM: approval.SCHEMA_NAME,
                    ATHENIX_OBJECT: approval.TABLE_NAME,
                    ATHENIX_FIELDS: approval.COLUMN_NAME,
                    Definition: approval.DATA,
                    PII_CHART: approval.PII_CHART || "",
                    "PII Y/N": approval.PII,
                    PII_COMP: currentSelection.selectPiiCompOption,
                    PII: currentSelection.selectAssociatePiiOption,
                    PII_TYPE: currentSelection.selectedPiiOption,
                    CLASSIFICATION_TYPE: currentSelection.selectClassificationTypeOption,
                    RTBF: approval.RTBF || "",
                    APPLY_TAG: approval.APPLY_TAG,
                    SOURCE_DB: approval.DB_NAME,
                    APPROVED: "Approved",
                    ID: approval.ID
                });
            });

            if (approvalPayloads.length === 0) return;

            const result = await submitClassificationApprovalTask(approvalPayloads);
            if (result) setShowSuccessfulClassificationApprovalAlert(true);

        } catch (error) {
            console.error("Error submitting approvals:", error);
            setShowFailureClassificationApprovalAlert(true);
        } finally {
            setLoadingElement(false); // Stop Loading
        }
    };

    const handleAllDenials = async (e) => {
        e.preventDefault();
        setLoadingElement(true); // Start Loading Indicator

        try {

            const denialPayloads = page.map(row => ({
                ENV: row.original.ENV,
                SOURCE_SYSTEM: row.original.SCHEMA_NAME,
                ATHENIX_OBJECT: row.original.TABLE_NAME,
                ATHENIX_FIELDS: row.original.COLUMN_NAME,
                Definition: row.original.DATA || "",
                PII_CHART: row.original.PII_CHART || '',
                'PII Y/N': row.original.PII,
                PII_COMP: row.original.PII_COMP,
                PII: row.original.PII,
                PII_TYPE: row.original.PII_TYPE,
                CLASSIFICATION_TYPE: row.original.CLASSIFICATION_TYPE,
                RTBF: row.original.RTBF || '',
                APPLY_TAG: row.original.APPLY_TAG,
                SOURCE_DB: row.original.DB_NAME,
                APPROVED: 'Denied',
                ID: row.original.ID || ''
            }));

            if (denialPayloads.length === 0) return;

            const result = await submitClassificationApprovalTask(denialPayloads);
            if (result) setShowSuccessfulClassificationApprovalAlert(true);

        } catch (error) {
            console.error("Error submitting batch denials:", error);
            setShowFailureClassificationApprovalAlert(true);
        } finally {
            setLoadingElement(false); // Stop Loading
        }
    };

    const handleDropdownSelect = (rowIndex, type, value, approval) => {

        setBatchApprovals((prevBatchApprovals) => {

            // Instead of matching by item.ID, compare by (db_name, schema_name, table_name, column_name)
            const isAlreadyIncluded = prevBatchApprovals.some((item) => {
                return (
                    item.DB_NAME === approval.DB_NAME &&
                    item.SCHEMA_NAME === approval.SCHEMA_NAME &&
                    item.TABLE_NAME === approval.TABLE_NAME &&
                    item.COLUMN_NAME === approval.COLUMN_NAME
                );
            });

            if (!isAlreadyIncluded) {

                const newBatchApprovals = [...prevBatchApprovals, approval];


                return newBatchApprovals;
            } else {

                return prevBatchApprovals;
            }
        });
        const updatedSelections = dropdownSelections.map((selection, index) => {
            if (index === rowIndex) {
                if (type === 'selectedPiiOption') {
                    return {
                        ...selection,
                        [type]: value,
                        selectPiiCompOption: '', // Clear PII_COMP
                        approval: approval // Add approval to updatedSelections
                    };
                }
                if (type === 'selectPiiCompOption' && value === 'Yes') {
                    return {
                        ...selection,
                        [type]: value,
                        selectedPiiOption: '', // Clear PII_TYPE
                        approval: approval // Add approval to updatedSelections
                    };
                }
                return {
                    ...selection,
                    [type]: value,
                    approval: approval // Add approval to updatedSelections
                };
            }
            return selection;
        });
        setDropdownSelections(updatedSelections);
    };

    const handleDenyApproval = async (e, approval, index) => {
        e.preventDefault();


        const currentSelection = dropdownSelections[currentApprovalIndex];


        const comparisons = {
            PII: approval.PII === currentSelection.selectAssociatePiiOption,
            PII_TYPE: approval.PII_TYPE === currentSelection.selectedPiiOption,
            CLASSIFICATION_TYPE: approval.CLASSIFICATION_TYPE === currentSelection.selectClassificationTypeOption,
            PII_COMP: approval.PII_COMP === currentSelection.selectPiiCompOption
        };



        Object.keys(comparisons).forEach(key => {
            if (comparisons[key]) {
                console.log(`${key} is the same.`);
            } else {
                console.log(`${key} is different.`);
            }
        });

        const newApproval = {
            SOURCE_SYSTEM: approval.SCHEMA_NAME,
            ATHENIX_OBJECT: approval.TABLE_NAME,
            ATHENIX_FIELDS: approval.COLUMN_NAME,
            Definition: approval.DATA,
            PII_CHART: approval.PII_CHART || '',
            'PII Y/N': approval.PII,
            PII_COMP: currentSelection.selectPiiCompOption,
            PII: currentSelection.selectAssociatePiiOption,
            PII_TYPE: currentSelection.selectedPiiOption,
            CLASSIFICATION_TYPE: currentSelection.selectClassificationTypeOption,
            RTBF: approval.RTBF || '',
            APPLY_TAG: approval.APPLY_TAG,
            SOURCE_DB: approval.DB_NAME,
            APPROVED: 'Denied',
            ID: currentApprovalIndex || ''
        };




        try {
            const result = await submitClassificationApprovalTask(newApproval);
            if (result) {

                setShowSuccessfulClassificationApprovalAlert(true);
            }
            console.log("Classification approval task submitted successfully.");
        } catch (error) {
            setShowFailureClassificationApprovalAlert(true);
            console.error("Error submitting classification approval task:", error);
        }
    };

    const chackbox = document.querySelectorAll(".bs_exam_topper input");
    const motherChackBox = document.querySelector(".bs_exam_topper_all input");
    const chackboxFun = (type) => {
        for (let i = 0; i < chackbox.length; i++) {
            const element = chackbox[i];
            if (type === "all") {
                if (motherChackBox.checked) {
                    element.checked = true;
                } else {
                    element.checked = false;
                }
            } else {
                if (!element.checked) {
                    motherChackBox.checked = false;
                    break;
                } else {
                    motherChackBox.checked = true;
                }
            }
        }
    };


    return (


        <div>
            <div className='row pt-5'>
          
                {/* <h1 className='title text-center'> Data Classification Trust Portal </h1> */}
            </div>
            <div className='row mt-4'>
                <p className='text-center' style={{ color: 'red', fontStyle: 'italic', fontSize: 'small' }}>
                    Must be connected to Lennar VPN to view data
                </p>
            </div>
            {adminUserType && (
                <div className='row mt-5'>
                    <Col lg={12}>
                        <Card>
                            <Card.Header>
                                <Card.Title>New Classification Approval Tasks</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ borderBottom: '2px solid #3d4465', paddingBottom: '10px', marginBottom: '10px' }}>
                                    {taskSummaries.map((summary, index) => {
                                        const tableCount = summary.match(/in tables (.*)/)[1].split(', ').length;
                                        const updatedSummary = summary.replace(/in tables .*/, `in ${tableCount} tables`);
                                        return <p key={index} style={{ color: '#3a7afe', fontWeight: 'bold' }}>{updatedSummary}</p>;
                                    })}
                                </div>


                                <Table {...getTableProps()} responsive className="mt-4">
                                    <thead>
                                        {headerGroups.map(headerGroup => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (

                                                    <th
                                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {column.canFilter ? column.render('Filter') : null}
                                                        {column.render('Header')}

                                                        <span>
                                                            {column.isSorted
                                                                ? column.isSortedDesc
                                                                    ? ' 🔽'
                                                                    : ' 🔼'
                                                                : ''}
                                                        </span>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>



                                    <tbody {...getTableBodyProps()}>
                                        {page.map(row => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()}>
                                                    {row.cells.map(cell => (
                                                        <td {...cell.getCellProps()}>
                                                            {cell.render('Cell')}
                                                        </td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>

                                {/* Pagination Controls */}
                                <div className="d-flex flex-column align-items-end mt-3">
                                    <div className="d-flex justify-content-center w-100">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleApproveAlert}
                                            disabled={batchApprovals.length === 0} // Button is disabled if nothing is selected
                                        >
                                            Apply All
                                        </button>
                                        <button
                                            className="btn btn-danger ms-2"
                                            onClick={handleDenyAllAlert}
                                        >
                                            Deny All
                                        </button>
                                    </div>

                                </div>
                                <div className="text-center">
                                    <div className="filter-pagination mt-3">
                                        <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                            {'<<'}
                                        </button>
                                        <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                            Previous
                                        </button>
                                        <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                            Next
                                        </button>
                                        <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                            {'>>'}
                                        </button>
                                    </div>
                                </div>
                                {showApproveAlert && (
                                    <div
                                        style={{
                                            position: 'fixed',
                                            top: '50%',
                                            left: '55%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1050,
                                            width: '80%',
                                            maxWidth: '600px'
                                        }}
                                    >
                                        <Alert
                                            variant="primary"
                                            className="notification"
                                            onClose={() => setShowApproveAlert(false)}
                                            dismissible
                                        >
                                            <p className="notification-title mb-2">
                                                <strong>Are you sure?</strong>
                                            </p>
                                            <p>Are you sure you want to classify all records selected?</p>
                                            <div>
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        handleAllApprovals(e);
                                                        setShowApproveAlert(false); // Close the alert
                                                    }}
                                                >
                                                    Confirm
                                                </Button>{' '}
                                                <Button variant="link" size="sm" onClick={() => setShowApproveAlert(false)}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </Alert>

                                    </div>

                                )}
                                {showSuccessfulClassificationApprovalAlert && (
                                    <div style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '55%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 1050,
                                        width: '80%',
                                        maxWidth: '600px'
                                    }}>
                                        <Alert variant="secondary" dismissible onClose={() => setShowSuccessfulClassificationApprovalAlert(false)} className="solid">

                                            <strong>Sucessfully Submitted Approvals </strong>
                                            <button type="button" className="btn-close" onClick={() => setShowSuccessfulClassificationApprovalAlert(false)}>
                                                <span><i className="mdi mdi-close" /></span>
                                            </button>
                                        </Alert>
                                    </div>
                                )}
                                {showDenyAllAlert && (
                                    <div
                                        style={{
                                            position: 'fixed',
                                            top: '50%',
                                            left: '55%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1050,
                                            width: '80%',
                                            maxWidth: '600px'
                                        }}
                                    >
                                        <Alert
                                            variant="danger"
                                            className="notification"
                                            onClose={() => setShowDenyAllAlert(false)}
                                            dismissible
                                        >
                                            <p className="notification-title mb-2">
                                                <strong>Are you sure?</strong>
                                            </p>
                                            <p>Are you sure you want to deny all the records in this page?</p>
                                            <div>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        handleAllDenials(e);
                                                        setShowDenyAllAlert(false); // Close the alert
                                                    }}
                                                >
                                                    Deny
                                                </Button>{' '}
                                                <Button variant="link" size="sm" onClick={() => setShowDenyAllAlert(false)}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </Alert>
                                    </div>
                                )}
                                {loadingElement && (
                                    <div style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "rgba(255, 255, 255, 0.7)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 1050
                                    }}>
                                        <div style={{
                                            width: "3rem",
                                            height: "3rem",
                                            border: "0.4rem solid rgba(0, 0, 255, 0.3)",
                                            borderTop: "0.4rem solid blue",
                                            borderRadius: "50%",
                                            animation: "spin 1s linear infinite"
                                        }} />
                                    </div>
                                )}



                            </Card.Body>
                        </Card>
                    </Col>
                </div>
            )}




            <div className='row mt-5'>

                <Col lg={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Tasks History</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {/* Global Filter */}
                            {/* <GlobalFilter globalFilter={historyGlobalFilter} setGlobalFilter={setHistoryGlobalFilter} /> */}

                            <Table {...getHistoryTableProps()} responsive>
                                <thead>
                                    {historyHeaderGroups.map(headerGroup => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map(column => (
                                                <th
                                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {column.canFilter ? column.render('Filter') : null}
                                                    {column.render('Header')}

                                                    <span>
                                                        {column.isSorted
                                                            ? (column.isSortedDesc ? ' 🔽' : ' 🔼')
                                                            : ''}
                                                    </span>
                                                </th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody {...getHistoryTableBodyProps()}>
                                    {historyPage.map((row) => {
                                        prepareHistoryRow(row);
                                        return (
                                            <tr {...row.getRowProps()}>
                                                {row.cells.map(cell => (
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render('Cell')}
                                                    </td>
                                                ))}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>

                            {/* Pagination Controls */}
                            <div className="d-flex flex-column align-items-end mt-3">
                                <span>
                                    Page{' '}
                                    <strong>
                                        {pageIndex + 1} of {pageOptions.length}
                                    </strong>{' '}
                                </span>
                                <span className="table-index mt-4">
                                    Go to page:{' '}
                                    <input
                                        type="number"
                                        className="ml-2"
                                        defaultValue={pageIndex + 1}
                                        onChange={e => {
                                            const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                                            gotoPage(pageNumber);
                                        }}
                                        style={{ width: '60px', marginLeft: '5px' }}
                                    />
                                </span>
                            </div>
                            <div className="text-center">
                                <div className="filter-pagination mt-3">
                                    <button className="previous-button" onClick={() => historyGotoPage(0)} disabled={!historyCanPreviousPage}>
                                        {'<<'}
                                    </button>
                                    <button className="previous-button" onClick={() => historyPreviousPage()} disabled={!historyCanPreviousPage}>
                                        Previous
                                    </button>
                                    <button className="next-button" onClick={() => historyNextPage()} disabled={!historyCanNextPage}>
                                        Next
                                    </button>
                                    <button className="next-button" onClick={() => historyGotoPage(historyPageCount - 1)} disabled={!historyCanNextPage}>
                                        {'>>'}
                                    </button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <div>
                    <Row className="justify-content-center">
                        <Col xs={12} md={3} style={{ paddingLeft: '0', display: 'flex', justifyContent: 'center' }}>
                            <Button style={{ width: '100%', maxWidth: '350px' }} variant="light" onClick={handleEDMTeamConnect}>
                                Connect with EDM Team
                            </Button>
                        </Col>
                    </Row>
                    {showEdmAlert && (
                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '56%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1050,
                            width: '100%',
                            maxWidth: '600px'
                        }}>
                            <Alert variant="secondary" dismissible onClose={() => setShowEdmAlert(false)} className="solid">

                                <strong>Done! </strong> EDM team has been notified and will reach out to you via email shortly.
                                <button type="button" className="btn-close" onClick={() => setShowEdmAlert(false)}>
                                    <span><i className="mdi mdi-close" /></span>
                                </button>
                            </Alert>
                        </div>
                    )}

                    {showRequestSampleDataAlert && (

                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '56%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1050,
                            width: '25%',
                            maxWidth: '1300px'
                        }}>
                            <Alert variant="primary" dismissible className="notification">
                                <p className="notificaiton-title mb-2">
                                    <strong>Sample Data </strong>
                                </p>
                                {/* <p className="notificaiton-title mb-2">
                                        <strong>Done!</strong> Vampires The Romantic Ideology
                                        Behind Them
                                    </p>
                                    <p>
                                        The following article covers a topic that has recently
                                        moved to center stage-at lease it seems that way.
                                    </p>
                                    <Button variant="primary" size="sm">
                                        Confirm
                                    </Button>
                                    <Button variant="link" size="sm">
                                        Cancel
                                    </Button> */}
                                <div style={{ textAlign: 'center' }}>
                                    <p>
                                        {sampleDataApproval && sampleDataApproval.DATA !== "NA" ? sampleDataApproval.DATA : "No sample data available"}
                                    </p>
                                </div>
                                <Button variant="link" size="sm" style={{ color: 'white', backgroundColor: 'darkblue' }} onClick={(e) => setShowRequestSampleDataAlert()}>
                                    Cancel
                                </Button>
                            </Alert>
                        </div>

                    )
                    }

                    {showSuccessfulClassificationApprovalAlert && (
                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '55%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1050,
                            width: '80%',
                            maxWidth: '600px'
                        }}>
                            <Alert variant="secondary" dismissible onClose={() => setShowSuccessfulClassificationApprovalAlert(false)} className="solid">

                                <strong>Sucessfully Submitted Approvals </strong>
                                <button type="button" className="btn-close" onClick={() => setShowSuccessfulClassificationApprovalAlert(false)}>
                                    <span><i className="mdi mdi-close" /></span>
                                </button>
                            </Alert>
                        </div>
                    )}


                    {showFailureClassificationApprovalAlert && (
                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '55%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1050,
                            width: '80%',
                            maxWidth: '600px'
                        }}>
                            <Alert variant="danger" dismissible onClose={() => setShowFailureClassificationApprovalAlert(false)} className="solid">

                                <strong>There was an Issue Applying Tags! </strong>                             <button type="button" className="btn-close" onClick={() => setShowFailureClassificationApprovalAlert(false)}>
                                    <span><i className="mdi mdi-close" /></span>
                                </button>
                            </Alert>
                        </div>
                    )}
                </div>
            </div>


        </div>

    )

}


export default DataClassificationApprovals;